import React from 'react'

const ProductRouter = () => {
  return (
    <div className='p-2'>
    <span>
    Home  ›  Laptops  ›  Everyday Use Notebooks  ›  MSI Prestige Series  ›  MSI WS Series</span>      
    </div>
  )
}

export default ProductRouter